import { render } from "./NewClaim.vue?vue&type=template&id=496e8074&scoped=true"
import script from "./NewClaim.vue?vue&type=script&lang=js"
export * from "./NewClaim.vue?vue&type=script&lang=js"

import "./NewClaim.vue?vue&type=style&index=0&id=496e8074&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496e8074"]])

export default __exports__